import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const userApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
userApiInstance.interceptors.request.use(requestInterceptor);

export default userApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/userApi.js